import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Stack } from '@optimus-web/core';
import { ColumnAlignment, MatrixMapping } from '@mews/b2b-ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';
import { Reservation } from '@mews-commander/data-access';
import { Table } from '@mews-commander/ui/legacy';
import { CustomerName } from '../../../../components/commander-ui';
import { DateGroup, getCheckedReservationIds } from '../../selectors';
import { DateGroupLabel } from '../DateGroupLabel';
import Actions from './Actions';
import ResourceSelect from './ResourceSelect';
import { getCheckedReservationsFilteredDateGroups } from './selectors';
import ResourceAssignTableActions from './ResourceAssignTableActions';
import ReservationHousekeepingStatus from './ReservationHousekeepingStatus';

interface OwnProps {
    scope: string;
}
interface StateProps {
    checkedDateGroups: DateGroup[];
    reservationIds: string[];
}
type Props = OwnProps & StateProps;

const getMapping = ({ intervalStartUtc, intervalEndUtc }: DateGroup): MatrixMapping<Reservation>[] => [
    {
        title: <DateGroupLabel startUtc={intervalStartUtc} endUtc={intervalEndUtc} />,
        valueKey: 'customerId',
        columnWidth: '25%',
        render: ({ customerId }) => customerId && <CustomerName id={customerId} />,
    },
    {
        title: <LocalizedText textKey={TextKey.Space} />,
        valueKey: 'assignedResourceId',
        columnWidth: '25%',
        render: ({ id, startUtc, endUtc, requestedCategoryId, assignedResourceId, serviceId, groupId }) => (
            <ResourceSelect
                key={`resource-select-${id}-${serviceId}`}
                startUtc={startUtc}
                endUtc={endUtc}
                serviceId={serviceId}
                requestedCategoryId={requestedCategoryId}
                assignedResourceId={assignedResourceId}
                reservationId={id}
                groupId={groupId}
            />
        ),
    },
    {
        // @ts-expect-error
        valueKey: 'housekeepingStatus',
        title: <LocalizedText textKey={TextKey.HousekeepingStatus} />,
        columnWidth: '25%',
        render: (reservation) => <ReservationHousekeepingStatus {...reservation} />,
    },
    {
        // @ts-expect-error
        valueKey: 'actions',
        columnWidth: '25%',
        columnAlignment: ColumnAlignment.Right,
        render: (reservation) => <Actions reservation={reservation} key={`actions-${reservation.id}`} />,
    },
];

const ResourceAssignTable = ({ checkedDateGroups, reservationIds, scope }: Props) =>
    checkedDateGroups.length === 0 ? null : (
        <Stack spacing="200" vertical>
            {checkedDateGroups.map((dateGroup) => (
                <Table
                    key={`interval-table-${dateGroup.intervalEndUtc}-${dateGroup.intervalEndUtc}`}
                    mapping={getMapping(dateGroup)}
                    source={dateGroup.reservations}
                />
            ))}
            <ResourceAssignTableActions reservationIds={reservationIds} scope={scope} />
        </Stack>
    );

export default connect<StateProps, null, OwnProps, ApplicationState>(
    createStructuredSelector({
        checkedDateGroups: getCheckedReservationsFilteredDateGroups,
        reservationIds: getCheckedReservationIds,
    })
)(ResourceAssignTable);
